import React from 'react';

export default function Video(props) {
  const media = props.media;

  function renderYoutube(video) {
    const embedURL = `https://www.youtube.com/embed/${video.external_id}?modestbranding=1&amp;rel=0&amp;loop=1`;
    return (
      <iframe 
        frameborder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen="false"
        clasNames="youtube"
        loading="lazy"
        src={embedURL}
        title={video.alt}
      />
    );
  }
  
  return media.video.host === 'youtube' ? renderYoutube(media.video) : '';
}